module.exports={Earlier:"PRECEDENTI",New:"NUOVI",NoAnnouncements:"Non sono presenti annunci"};